import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { TodoRefreshService } from '../services/todo_refresh_service';
import { PathTask } from './../builders/path_task_builder';
import { PathTaskUpdateService } from './../services/path_task_update_service';
import { TodoDateRangeService } from './../services/todo_date_range_service';

angular
  .module('data-ng-todos')
  .factory(
    'updateTaskStatusAndModelsCommand',
    function updateTaskStatusAndModelsCommandDefinition(
      defineCommand: IDefineCommand,
      ngPathTaskDatastore: IDatasource<PathTask>,
      ngOverduePathTaskDatastore: IDatasource<PathTask>,
      ngPathTaskUpdateService: PathTaskUpdateService,
      TaskStatusEnum: any,
      ngTodoDateRangeService: TodoDateRangeService,
      pathTasksVisibilityModel: any,
      $http: ng.IHttpService,
      ngTodoRefreshService: TodoRefreshService
    ) {
      return defineCommand(
        'updateTaskStatusAndModelsCommand',
        function updateTaskStatusAndModelsCommand(
          deferred,
          requestedStatus,
          task: PathTask,
          isAutoComplete,
          addedToCalendar
        ) {
          addedToCalendar = addedToCalendar || false;

          const updateStatusTo = TaskStatusEnum.get(requestedStatus);
          let updatedStatus: string;
          const pathStatus = task.status.toUpperCase();

          if (_4.isUndefined(updateStatusTo)) {
            return deferred.resolve(task);
          }

          updatedStatus = updateStatusTo.key.toUpperCase();

          $http
            .put('event/task/event/' + task.event + '/repeated_by/' + task.repeated_by, {
              task_status: updatedStatus,
              calendar_synced: addedToCalendar,
              is_pending_complete: isAutoComplete,
              start_dt: ngTodoDateRangeService.getCurrentDateRange().start,
              end_dt: ngTodoDateRangeService.getCurrentDateRange().end,
              path_status: pathStatus,
              cache: false
            })
            .then(({ data }: any) => {
              task.status = updatedStatus;
              task.is_pending_complete = isAutoComplete;
              deferred.resolve(task);

              if (!_4.includes(['COMPLETED', 'DISMISSED'], pathStatus)) {
                pathTasksVisibilityModel.update(data);
                ngTodoRefreshService.checkForUpdates();
              }

              // start datastore updating
              const { status, show, is_pending_complete, is_overdue } = task;
              const id = `${task.event}_${task.repeated_by}`;
              ngPathTaskUpdateService.updatePathTask(task, {
                id,
                status,
                show,
                is_pending_complete,
                is_overdue
              } as PathTask);

              const server_task: Partial<PathTask> = _4.first(data.task) || {};
              const updatedPathTask: PathTask = { ...task, ...server_task, id };
              ngPathTaskDatastore.put(updatedPathTask);

              ORM.run(ngPathTaskDatastore);
              ORM.run(ngOverduePathTaskDatastore);
            })
            .catch((reason: any) => {
              deferred.reject(reason);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/update_task_status_and_models_command.ts